<template>
    <img :src="logoImage" @error="logoImageOnError" />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { DealDetails } from '@/classes/DealDetails'
const props = defineProps<{
    deal: DealDetails
    index?: number
}>()

const logoImageIndex = ref(0)

const logoImage = computed(() => {
    if (props.deal.dealProvider && logoImageIndex.value === 0) {
        return `/assets/img/logos/${props.deal.dealProvider.toLowerCase()}.png`
    }
    else if (props.deal.dealProvider && logoImageIndex.value === 1) {
        return `/assets/img/logos/${props.deal.dealProvider.toLowerCase()}.jpg`
    }
    else {
        return '/assets/img/logos/amazon.png'
    }
})

const logoImageOnError = () => {
    logoImageIndex.value++
}
</script>